export const tradersList = [
  // ================= REAL USERS (KEEP AS IT IS) =================

  // ================= AVATAR USERS (1–20) =================

  {
    id: 101,
    name: "Arjun Patel",
    category: "Forex Trader",
    country: "India",
    status: "online",
    photo: "/assets/data/users/traders/trader1.jpg",
    followers: "6.8K",
    likes: "4.9K",
    badges: ["Verified"],
  },

  {
    id: 102,
    name: "Sophia Lee",
    category: "Crypto Trader",
    country: "Singapore",
    status: "offline",
    photo: "/assets/Data/users/traders/trader2.jpg",
    followers: "9.1K",
    likes: "7.4K",
    badges: ["Verified"],
  },
  {
    id: 103,
    name: "Daniel Morgan",
    category: "Equity Trader",
    country: "United Kingdom",
    status: "online",
    photo: "/assets/data/users/traders/trader3.jpg",
    followers: "11.6K",
    likes: "8.2K",
    badges: ["Top Performer", "Verified"],
  },
  {
    id: 104,
    name: "Aisha Khan",
    category: "Indices Trader",
    country: "UAE",
    status: "online",
    photo: "/assets/data/users/traders/trader4.jpg",
    followers: "7.9K",
    likes: "5.3K",
    badges: ["Verified"],
  },
  {
    id: 105,
    name: "Michael Brown",
    category: "Commodities Trader",
    country: "United States",
    status: "offline",
    photo: "/assets/data/users/traders/trader5.jpg",
    followers: "13.4K",
    likes: "10.1K",
    badges: ["Verified"],
  },
  {
    id: 106,
    name: "Chen Wei",
    category: "Crypto Trader",
    country: "Hong Kong",
    status: "online",
    photo: "/assets/data/users/traders/trader6.jpg",
    followers: "14.2K",
    likes: "11.6K",
    badges: ["Top Performer", "Verified"],
  },
  {
    id: 107,
    name: "Ahmed Hassan",
    category: "Forex Trader",
    country: "Qatar",
    status: "offline",
    photo: "/assets/data/users/traders/trader7.jpg",
    followers: "5.7K",
    likes: "3.9K",
    badges: ["Verified"],
  },

  {
    id: 108,
    name: "Lucas Silva",
    category: "Stocks Trader",
    country: "Brazil",
    status: "online",
    photo: "/assets/data/users/traders/trader8.jpg",
    followers: "8.6K",
    likes: "6.2K",
    badges: ["Verified"],
  },
  {
    id: 109,
    name: "Omar Farouk",
    category: "Gold Trader",
    country: "Egypt",
    status: "online",
    photo: "/assets/data/users/traders/trader9.jpg",
    followers: "12.1K",
    likes: "9.7K",
    badges: ["Top Performer", "Verified"],
  },
  {
    id: 110,
    name: "Emily Carter",
    category: "Options Trader",
    country: "Canada",
    status: "offline",
    photo: "/assets/data/users/traders/trader10.jpg",
    followers: "7.3K",
    likes: "5.6K",
    badges: ["Verified"],
  },
  {
    id: 111,
    name: "Rajesh Mehta",
    category: "Intraday Trader",
    country: "India",
    status: "online",
    photo: "/assets/data/users/traders/trader11.jpg",
    followers: "9.9K",
    likes: "7.8K",
    badges: ["Verified"],
  },
  {
    id: 112,
    name: "Natalie Wong",
    category: "Swing Trader",
    country: "Malaysia",
    status: "offline",
    photo: "/assets/data/users/traders/trader12.jpg",
    followers: "6.2K",
    likes: "4.1K",
    badges: ["Verified"],
  },
  {
    id: 113,
    name: "Peter Novak",
    category: "ETF Trader",
    country: "Germany",
    status: "online",
    photo: "/assets/data/users/traders/trader13.jpg",
    followers: "10.8K",
    likes: "8.4K",
    badges: ["Verified"],
  },
  {
    id: 114,
    name: "Fatima Noor",
    category: "Crypto Analyst",
    country: "Pakistan",
    status: "online",
    photo: "/assets/data/users/traders/trader14.jpg",
    followers: "11.2K",
    likes: "9.1K",
    badges: ["Top Performer", "Verified"],
  },
  {
    id: 115,
    name: "James Walker",
    category: "Derivatives Trader",
    country: "Australia",
    status: "offline",
    photo: "/assets/data/users/traders/trader15.jpg",
    followers: "8.1K",
    likes: "6.7K",
    badges: ["Verified"],
  },
  {
    id: 116,
    name: "Sunita Iyer",
    category: "Long-term Investor",
    country: "India",
    status: "online",
    photo: "/assets/data/users/traders/trader16.jpg",
    followers: "14.9K",
    likes: "12.3K",
    badges: ["Top Performer", "Verified"],
  },
  {
    id: 117,
    name: "Carlos Mendes",
    category: "Futures Trader",
    country: "Portugal",
    status: "online",
    photo: "/assets/data/users/traders/trader17.jpg",
    followers: "6.9K",
    likes: "5.1K",
    badges: ["Verified"],
  },
  {
    id: 118,
    name: "Hiro Tanaka",
    category: "Index Trader",
    country: "Japan",
    status: "offline",
    photo: "/assets/data/users/traders/trader18.jpg",
    followers: "9.4K",
    likes: "7.6K",
    badges: ["Verified"],
  },
  {
    id: 119,
    name: "Zain Ali",
    category: "Scalper",
    country: "Saudi Arabia",
    status: "online",
    photo: "/assets/data/users/traders/trader19.jpg",
    followers: "5.8K",
    likes: "4.3K",
    badges: ["Verified"],
  },
  {
    id: 120,
    name: "Laura Fernandez",
    category: "Portfolio Trader",
    country: "Spain",
    status: "online",
    photo: "/assets/data/users/traders/trader20.jpg",
    followers: "13.7K",
    likes: "11.2K",
    badges: ["Top Performer", "Verified"],
  },
];
